<div class="flex flex-row justify-end items-center">
  <button mat-icon-button class="close-button" mat-dialog-close>
    <mat-icon class="close-icon" color="accent">close</mat-icon>
  </button>
</div>
<h2 class="font-bold text-xl" mat-dialog-title>
  {{ utils.traslatei18n("infoRecoveryPlanTitle") }}
</h2>
<div class="w-full sm:p-8 p-2 ">

  <div class="grid sm:grid-cols-3 grid-cols-2 py-4">
    <div *ngFor="let item of info">
      <div class="w-full flex flex-col px-4 py-2">
        <div class="bold text-black text-lg">{{ utils.traslatei18n(item.title) }}</div>
        <div >{{ item.value }}</div>
      </div>
    </div>
  </div>

  <div class="w-full p-2">
    <div class="w-full p-2 border-[2px] border-solid rounded-lg mb-2">
      <div
        class="flex flex-row justify-between cursor-pointer py-2"
        [ngClass]="{ 'pb-4 border-solid border-b-[1px]': openInfo }"
        (click)="openInfo = !openInfo"
      >
        <div class="flex flex-row justify-start items-center pl-2 text-black">
          {{ utils.traslatei18n("Comments/Actions") }}
        </div>

        <mat-icon *ngIf="!openInfo">keyboard_arrow_down</mat-icon>

        <mat-icon *ngIf="openInfo">expand_less</mat-icon>
      </div>
      <div *ngIf="openInfo" class="h-[200px] overflow-auto">
        <div *ngFor="let item of data.additionalInformation" class="border-solid border-b-[1px]">
          <div class="w-full p-2 flex flex-row justify-start items-start font-bold">
            <div class="text-md">
              {{ item.type === 0 ? utils.traslatei18n("Comment") : utils.traslatei18n("Action") }}
            </div>
          </div>
          <div class="w-full p-2 text-black/60">
            {{ item.additionalInfo }}
          </div>
          <div class="w-full p-2 flex flex-row justify-end items-start font-bold">
            <div class="flex flex-col justify-center items-end">
              <div class="text-xs text-black/60">
                {{ item.usrInsert ? item.usrInsert : "" }}
              </div>
              <div class="text-xs text-black/50">
                {{ parseDate(item.dtInsert) }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div
    *ngIf="data.attach"
    matRipple
    class="w-full flex flex-col items-center px-6 py-6 bg-white text-blue rounded-lg border-2 border-[#223e80] border-dashed tracking-wide uppercase cursor-pointer mt-10"
    (click)="downloadFile()"
  >
    <img src="../../../../assets/svg/load.svg" class="w-8 h-8 text-[#223e80]" />
    <button mat-button>
      <div class="flex flex-row justify-between items-center">
        <div class="mt-2 text-base leading-normal">Download File</div>
        <mat-icon class="mx-2">download</mat-icon>
      </div>
    </button>
  </div>
</div>
